import classNames from 'classnames';

import useNavigateWithPreservedSearchParams from '@/hooks/use-navigate-with-preserved-search-params';
import DynamicT from '@/shared/components/DynamicT';

import styles from './index.module.scss';

type Props = { readonly active: 'sign-in' | 'register' };

const AuthenticationTabs = ({ active }: Props) => {
  const navigate = useNavigateWithPreservedSearchParams();

  return (
    <div className={styles.tabs} role="tablist" aria-label="Account access">
      <button
        type="button"
        role="tab"
        aria-selected={active === 'sign-in'}
        className={classNames(active === 'sign-in' && styles.active)}
        onClick={() => {
          navigate('/sign-in', { replace: true });
        }}
      >
        <DynamicT forKey="action.sign_in" />
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={active === 'register'}
        className={classNames(active === 'register' && styles.active)}
        onClick={() => {
          navigate('/register', { replace: true });
        }}
      >
        <DynamicT forKey="action.create_account" />
      </button>
    </div>
  );
};

export default AuthenticationTabs;
